module.exports = __webpack_public_path__ + "img/captcha-code.25aa2cdd.png";